import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ExcRestService} from 'exc-rest-v2';
import {ExgModalService} from 'exc-controls-v2';
import {ExcTranslation} from 'exc-core-v2';
import {CalculationSpreadsheetComponent} from '../calculation-spreadsheet/calculation-spreadsheet.component';
import {EnumerationService} from '../../services/enumeration.service';
import {ExcSecurityService} from 'exc-security-v2';

@Component({
  selector: 'app-calculation-template',
  templateUrl: './calculation-template.component.html',
  styles: [
  ]
})
export class CalculationTemplateComponent extends ExcTranslation implements OnInit {

  @ViewChild(CalculationSpreadsheetComponent) VCSpreadsheet!: CalculationSpreadsheetComponent;
  @Input() version!: any;

  @Input()
  tabinstance: any;

  Data: any;

  isNew = false;
  loaded = false;
  closeTabinstance = false;

  ID: string | undefined = undefined;
  ctData: {
    ctID: string | undefined,
    ctUPT: string | undefined,
    ct_oeID: string | undefined,
    ctData: any,
    ctName?: any,
    ctDescription?: any,
    ctAutoFillColumns: string | undefined
  } = {
    ctID: undefined,
    ctUPT: undefined,
    ct_oeID: undefined,
    ctData: undefined,
    ctAutoFillColumns: undefined
  };
  contextMenueSubitems = [] as any[];
  autoFillColumns = [] as any[];

  constructor(
    private excRest: ExcRestService,
    private modal: ExgModalService,
    private enumSrv: EnumerationService,
    public excSecurity: ExcSecurityService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.initialize();
    this.tabinstance.BeforeClose = () => {
      return this.checkBeforeClose();
    };
  }

  initialize(): void {
    if (this.Data.isNewFromPreset) {
      this.isNew = true;
      this.ctData = {
        ctID: undefined,
        ctUPT: undefined,
        ct_oeID: this.version.cv_ctID,
        ctData: JSON.stringify(this.version.cvData),
        ctName: this.version.cvName,
        ctDescription: this.version.cvDescription,
        ctAutoFillColumns: ''
      };
      this.loaded = true;
      return;
    } else
    {
      this.excRest.get(this.excRest.computeUrl('CalculationTemplateR', {ctID: this.Data.ctID, fkID: undefined}))
        .subscribe((response: any) => {
          if (response?.success) {
            this.ctData = response.data.CalculationTemplate;
            this.initTemplateKeys(response.data.ForeignData);
            this.loaded = true;
          }
        });
    }
  }

  initTemplateKeys(keys: any): void {
    if (this.contextMenueSubitems.length === 0) {
      for (const key of this.getFieldNames(keys)) {
        const keyTable =
          key.startsWith('aue') ? 'AuftragE_EIS' :
            key.startsWith('au') ? 'Auftrag' :
              key.startsWith('vorg') ? 'Vorgang' :
                key;
        const value = {
          text: keyTable !== key ? this.enumSrv.getFieldCaption(keyTable, key) : key.replace('_', ' ')
          , id: key // Value
        };
        this.contextMenueSubitems.push(value);
      }
    }
  }

  getFieldNames(data: object): string[] {
    return Object.keys(data);
  }

  async calculationSave(cancelSave = false, $event?: any): Promise<void> {
    this.VCSpreadsheet.getAutoFillColumns();
    if ($event) {
      this.save(cancelSave, $event.jsonWorkbook);
    } else {
      this.VCSpreadsheet.spreadsheetObj.saveAsJson()
        .then((json: any) => {
          this.save(cancelSave, json.jsonObject);
        });
    }
  }

  save(cancelSave = false, jsonWorkbook: any): void {
    if (cancelSave) {
      this.VCSpreadsheet.isDirty = false;
      this.isNew = false;

      this.modal.showToast(
        this.getResource('Canceled'),
        'md-toast',
        'far fa-window-close'
      );

      this.closeTab();
      return;
    }

    this.ctData.ctData = JSON.stringify(jsonWorkbook);
    this.ctData.ctAutoFillColumns = JSON.stringify(this.autoFillColumns);

    if (this.isNew) {
      this.excRest.put(this.excRest.computeUrl('CalculationTemplateU', {}), this.ctData)
        .subscribe((response: any) => {
          if (response?.success) {
            this.ctData = response.data.CalculationTemplate;
            this.isNew = false;
            this.loaded = true;
            this.VCSpreadsheet.isDirty = false;

            this.modal
              .showToast('Kalkulation gespeichert'
                , 'md-toast bg-green'
                , 'far fa-check');
          }
          this.closeTab();
        });
    } else {
      if (!this.VCSpreadsheet.isDirty) {
        return;
      }
      this.excRest.put(this.excRest.computeUrl('CalculationTemplateU', {
        ctID: this.ctData.ctID
      }), this.ctData).subscribe((response: any) => {
        if (response?.success) {
          this.ctData = response.data.CalculationTemplate;
          this.loaded = true;
          this.VCSpreadsheet.isDirty = false;

          this.modal
            .showToast('Kalkulation gespeichert'
              , 'md-toast bg-green'
              , 'far fa-check');
        }
        this.closeTab();
      });
    }
  }

  setAutoFillColumns(autoFillColumns: []): void {
    this.autoFillColumns = autoFillColumns;
  }

  openModalOeCalculationComponent(config?: any): void {
    this.modal.show('ModalOeCalculationComponent', config)
      .subscribe((rtVal: any) => {
        if (rtVal) {
          if (rtVal?.del) {
            this.excRest
              .delete(
                this.excRest.computeUrl('OECalculationCUD', {
                  oeID: this.ctData.ct_oeID,
                }), {
                  ctID: rtVal.ctID,
                  ctUPT: rtVal.ctUPT
                }
              )
              .subscribe((ret: any) => {
                if (ret.success) {
                  this.modal
                    .showToast('Kalkulation gelöscht'
                      , 'md-toast bg-green'
                      , 'far fa-check');
                }
                this.tabinstance.Close();
              });
          } else {
            const dataObject = {
              ctName: rtVal.ctName,
              ctDescription: rtVal.ctDescription,
              ct_aue_enmIdent_Versicherungsart: rtVal.ct_aue_enmIdent_Versicherungsart,
              ct_enmIdent_DokTyp: rtVal.ct_enmIdent_DokTyp
            };

            if (rtVal && rtVal.ctID) {
              Object.assign(
                dataObject, {
                  ctID: rtVal.ctID,
                  ctUPT: rtVal.ctUPT
                });
            }

            this.excRest
              .post(this.excRest.computeUrl('OECalculationCUD', {
                oeID: this.Data.oeID
              }), dataObject)
              .subscribe((ret: any) => {
                if (ret.success) {
                  if (rtVal.ctID) {
                    this.ctData = ret.data[0];
                    this.Data.Events?.OE?.Summary?.Reload?.emit();
                    this.modal
                      .showToast('Kalkulation geändert',
                        'md-toast bg-green',
                        'far fa-check');
                  }
                }
              });
          }
        }
      });
  }

  checkBeforeClose(): boolean {
    if (!this.VCSpreadsheet?.isDirty && !this.isNew) {
      return true;
    }
    this.modal
      .showSimple(
        this.getGlobal('Attention') + '!',
        this.getResource('UnsavedChanges'),
        true,
        true,
        this.getGlobal('Save'),
        this.getGlobal('Reject')
      )
      .subscribe(async (ret: boolean) => {
        this.closeTabinstance = true;
        this.calculationSave(!ret);
      });
    return false;
  }

  closeTab(): void {
    if (this.closeTabinstance) {
      this.tabinstance.Close();
    }
  }
}
